import { useCallback, useEffect, useMemo } from 'react';

import { useSelector } from 'react-redux';
import { useIntl } from '@edx/frontend-platform/i18n';
import { useToggle } from '@openedx/paragon';
import { StrictDict, useKeyedState } from '@edx/react-unit-test-utils';

import messages from './messages';

const hasSeenTranslationTourKey = 'hasSeenTranslationTour';

export const stateKeys = StrictDict({
  showTranslationTour: 'showTranslationTour',
});

const useTranslationTour = () => {
  const { formatMessage } = useIntl();

  const { showCoursewareTour } = useSelector(state => state.tours);

  const [isTourEnabled, setIsTourEnabled] = useKeyedState(
    stateKeys.showTranslationTour,
    false,
  );
  const [isOpen, open, close] = useToggle(false);

  const endTour = useCallback(() => {
    global.localStorage.setItem(hasSeenTranslationTourKey, 'true');
    setIsTourEnabled(false);
  }, [isTourEnabled, setIsTourEnabled]);

  const tryIt = useCallback(() => {
    endTour();
    open();
  }, [endTour, open]);

  const translationTour = useMemo(() => ({
    tourId: 'translation',
    enabled: isTourEnabled,
    onDismiss: endTour,
    onEnd: tryIt,
    checkpoints: [
      {
        title: formatMessage(messages.translationTourModalTitle),
        body: formatMessage(messages.translationTourModalBody),
        placement: 'bottom',
        target: '#translation-selection-button',
        showDismissButton: true,
        endButtonText: formatMessage(messages.tryItButtonText),
        dismissButtonText: formatMessage(messages.dismissButtonText),
      },
    ],
  }), [isTourEnabled]);

  useEffect(() => {
    setIsTourEnabled(
      !showCoursewareTour
        && global.localStorage.getItem(hasSeenTranslationTourKey) !== 'true',
    );
  }, [showCoursewareTour]);

  return {
    translationTour,
    isOpen,
    open,
    close,
  };
};

export default useTranslationTour;
